/* Joe Luxe hero brand name: opens large and centred on the screen and, in step with
   the hero (its --p, from the landing animation or joe-luxe.js), slides up and
   shrinks onto the header logo, then hands over to it. Fixed + transform/opacity
   only; measures the real header logo so it lands on it on every screen. */
(function () {
  var hero = document.querySelector('.jl-hero');
  var brand = hero && hero.querySelector('.jl-hero__brand');
  if (!brand) return;
  var root = document.documentElement;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    root.style.removeProperty('--jl-logo');
    return;
  }

  var logo = document.querySelector('.header-logo');
  var y0 = 0;
  var endScale = 0.3;
  var onScreen = true;
  var queued = false;

  function measure() {
    y0 = (window.innerHeight - brand.offsetHeight) / 2; /* centred on the screen */
    var bf = parseFloat(getComputedStyle(brand).fontSize) || 52;
    var lf = logo ? parseFloat(getComputedStyle(logo).fontSize) || 16 : 16;
    endScale = Math.min(1, lf / bf);
  }

  function progress() {
    var p = parseFloat(hero.style.getPropertyValue('--p'));
    return isNaN(p) ? 1 : p;
  }

  function render() {
    queued = false;
    /* holds centred for the first moment, then slides up; done just before the piece lands */
    var t = Math.max(0, Math.min(1, (progress() - 0.08) / 0.8));
    var p = t * t * (3 - 2 * t);
    var y1 = 14;
    if (logo) {
      var r = logo.getBoundingClientRect();
      y1 = r.top + r.height / 2 - (brand.offsetHeight * endScale) / 2;
    }
    var y = y0 + (y1 - y0) * p;
    var sc = 1 - (1 - endScale) * p;
    brand.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(' + sc.toFixed(4) + ')';
    /* crossfade to the real logo only once it sits exactly on it */
    brand.style.opacity = onScreen ? Math.max(0, Math.min(1, (1 - p) * 40)).toFixed(3) : '0';
    root.style.setProperty('--jl-logo', Math.max(0, Math.min(1, (p - 0.975) * 40)).toFixed(3));
  }

  function queue() {
    if (!queued) {
      queued = true;
      window.requestAnimationFrame(render);
    }
  }

  new MutationObserver(queue).observe(hero, { attributes: true, attributeFilter: ['style'] });
  new IntersectionObserver(function (entries) {
    onScreen = entries[0].isIntersecting;
    queue();
  }).observe(hero);
  window.addEventListener('resize', function () {
    measure();
    queue();
  });

  measure();
  brand.classList.add('is-live');
  render();
})();
